<template>
    <vx-expandable-card class="lg:max-w-(--breakpoint-sm)">
        <template v-slot:header> Redirect Number </template>

        <template v-slot:content>
            <div v-if="loading" class="flex justify-center mt-3">
                <vx-icon-loading spin></vx-icon-loading>
            </div>

            <div v-else-if="failed" class="flex flex-col gap-6 mt-3">
                <vx-alert color="danger" :closeable="false">Failed to load data.</vx-alert>
                <vx-button size="lg" @click="loadShiftToTextRedirectNumber"> Reload </vx-button>
            </div>
            <div v-else class="flex gap-3 mt-3">
                <vx-input placeholder="Phone number" type="text" v-model="redirect" />
                <vx-button
                    color="info"
                    data-test="clear"
                    :disabled="saving || redirect == ''"
                    @click="
                        redirect = '';
                        updateShiftToTextRedirect();
                    "
                >
                    Clear
                </vx-button>
                <vx-button data-test="update" :disabled="saving || redirect == ''" @click="updateShiftToTextRedirect">
                    Update
                </vx-button>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { ref } from 'vue';
import { teamsClient } from '~/services';
import { VxAlert, VxButton, VxInput, VxExpandableCard, VxIconLoading, VxSwal } from '@voxie/frontend-components';
import { useToasted } from '~/composables/useToasted';

const failed = ref(false);
const loading = ref(true);
const redirect = ref('');
const saving = ref(false);
const toasted = useToasted();

const loadShiftToTextRedirectNumber = () => {
    loading.value = true;
    teamsClient
        .getShiftToTextRedirect(Spark.state.currentTeam.id)
        .then((r) => {
            failed.value = false;
            redirect.value = r.data?.redirect || '';
        })
        .catch(() => {
            failed.value = true;
        })
        .finally(() => {
            loading.value = false;
        });
};

const updateShiftToTextRedirect = () => {
    saving.value = true;
    teamsClient
        .updateShiftToTextRedirect(Spark.state.currentTeam.id, redirect.value)
        .then(() => {
            VxSwal.fire({
                title: 'Success!',
                text: 'Shift to Text redirect number was updated.',
                icon: 'success',
            });
        })
        .catch((error) => {
            console.error(error);
            toasted.global.platform_error();
        })
        .finally(() => {
            saving.value = false;
        });
};

loadShiftToTextRedirectNumber();
</script>
